import React from "react";
import { useTranslation } from "react-i18next";

import { AIHazardSeverity } from "./types";

interface SeverityBadgeProps {
  severity: AIHazardSeverity;
}

// Stage-1 triage hint only — the severity never lands on the final Risk
// (the real assessment params are decided in Phase B).
const SEVERITY_OUTLINE: Record<AIHazardSeverity, string> = {
  high: "border-red-300 text-red-600",
  medium: "border-amber-300 text-amber-700",
  low: "border-gray-300 text-gray-500",
};

export const SeverityBadge = ({ severity }: SeverityBadgeProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 border rounded text-xs font-medium ${SEVERITY_OUTLINE[severity]}`}
    >
      {t(`risks.ai.severity.${severity}`)}
    </span>
  );
};
